import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIcons1passwordComponent } from './simple-icons-1password.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIcons1passwordComponent ],
    exports:      [ SimpleIcons1passwordComponent ],
    bootstrap:    []
})
export class SimpleIcons1passwordModule {}
